import React, { Component, createRef } from 'react';
import { message, Pagination, Modal } from 'antd';
import CpEmpty from '../../components/CpEmpty';
import { statusTextToIndex } from './statusConfig';
import send from '../../util/request';
import RenderList from './components/renderList';
import { SearchForm } from './components/searchForm';
import moment from 'moment';
import './style.less';
import { enquiryOrders } from './api';
class OrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: [],
      formateList: [],
      currentStatus: undefined,
      emptyStatus: 'enquiryList',
      loading: true,
      paginationProps: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (current, pageSize) => this.pageChanged(current, pageSize)
      },
      messageInfo: {
        visible: false,
      },
      logisticsVisible: false,//物流详情弹框
      orderStatus: undefined,//订单编号
      logisticsData: []//物流数据
    };
    this.searchRef = createRef();
  }

  componentDidMount() {
    const params = { page: 1, page_size: 10, status: undefined };
    this.requestOrderList(params);
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  searchFn = () => {
    const { paginationProps: { pageSize } } = this.state;
    this.requestOrderList({ page: 1, page_size: pageSize, status: undefined });
  }

  requestOrderList = async (params = {}) => {
    const { dateRange = [], ...formValues } = this.searchRef?.form?.getFieldsValue() || {};
    // const { order_status } = formValues;
    // const newFormValues = +order_status === 10 ? { ...formValues, order_status: '' } : formValues;
    let { page: current = 1, page_size: pageSize = 10 } = params;
    this.setState({
      // currentStatus,
      // activeStatus: statusIndexToText[currentStatus],
      paginationProps: { ...this.state.paginationProps, current, pageSize }
    });

    // console.log(newFormValues, 'newFormValues', formValues, '[[[[[', this.searchRef?.form?.getFieldsValue());

    const [start_date, end_date] = dateRange.map(item => moment(item).format('YYYY-MM-DD'));
    const { data: { data: { list = [], page, total }, msg, code } } = await enquiryOrders({ ...formValues, start_date, end_date, ...params });
    if (+code === 0) {
      this.setState({
        paginationProps: { ...this.state.paginationProps, current: Number(page), total: Number(total) },
        orderList: list.map(item => ({ ...item, isExpand: true })),
        // emptyStatus: (list.length <= 0 && params.status === undefined) ? 'order' : '',
        loading: false
      });
    } else {
      message.error(msg);
    }
  }

  toOrderDetail = (item, report = 0) => {
    this.props.history.push('/basic/user/enquiryOrder/detail/' + item.order_no);
  }

  stateChanged = (e) => {
    const { key } = e;
    let status = statusTextToIndex[key];
    this.setState({
      activeStatus: key,
      currentStatus: status
    });

    let { current, pageSize } = this.state.paginationProps;
    this.requestOrderList({ page: current, page_size: pageSize, status });
  }

  btnClicked = (item) => {
    const { buttonText, orderNo, orderStatus } = item;
    const status = orderStatus === 30 ? 40 : 50;
    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: orderNo,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(buttonText + '成功');
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  changeStatus = async (item) => {
    const { receiveInfo = [], orderNo: order_no, orderNo, orderStatus } = item;
    if (receiveInfo.length) {
      const { data: { msg, code } } = await send({ url: '/ipp/order-purchase/finish', method: 'POST', data: { order_no } });
      if (+code === 0) {
        message.success(msg);
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(msg);
      }
    } else {
      // this.btnClicked(item);
      const status = orderStatus === 30 ? 40 : 50;
      send({
        url: '/ipp/order-purchase/status',
        method: 'POST',
        data: {
          id: orderNo,
          status
        }
      }).then(res => {
        if (res.data && res.data.code === 0) {
          const title = `确定${item.orderStatus === 20 ? '取消' : `${item.receiveInfo.length ? '完结订单' : '收货'}`}`;
          message.success(title + '成功');
          const { currentStatus, paginationProps: { current, pageSize } } = this.state;
          this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
        } else {
          message.error(res.data.msg);
        }
      });
    }
  }

  handleCancel = () => {
    this.setState({
      modalVisible: false
    });
  }

  handleOk = () => {
    const { currentOrder } = this.state;
    const { orderNo, orderStatus, buttonText } = currentOrder;
    const status = orderStatus === 30 ? 40 : 50;

    this.setState({
      modalVisible: false
    });

    send({
      url: '/ipp/order-purchase/status',
      method: 'POST',
      data: {
        id: orderNo,
        status
      }
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success(buttonText + '成功');
        const { currentStatus, paginationProps: { current, pageSize } } = this.state;
        this.requestOrderList({ page: current, page_size: pageSize, status: currentStatus });
      } else {
        message.error(res.data.msg);
      }
    });
  }

  pageChanged = (page, pageSize) => {
    let { currentStatus } = this.state;
    this.requestOrderList({ page, page_size: pageSize, status: currentStatus });
  }

  toProductDetail = (product) => {
    const { supplier_id, sale_id, norms_id } = product;

    if (!norms_id || !supplier_id || !sale_id) {
      message.info('商品缺少spu_id或sale_id或supplier_id');
      return;
    }

    this.props.history.push('/basic/product/detail/' + sale_id + '/' + supplier_id + '/' + norms_id);
  }

  expandFn = (item) => {
    const { isExpand, order_no } = item;
    const { orderList = [] } = this.state;
    const newOrderList = orderList.map(item => order_no === item.order_no ? { ...item, isExpand: !isExpand } : item);
    this.setState({ orderList: newOrderList });
  }

  onHandlerClose = () => {
    this.setState({
      messageInfo: {
        visible: false,
      }
    });
  }

  handleLogistics = (item) => {
    this.setState({
      logisticsVisible: true,
      orderStatus: item.status
    }, () => {
      this.getLogistics(item);
    });
  }

  handleLogCancel = () => {
    this.setState({
      logisticsVisible: false
    });
  }

  perfectInformation = (item) => {
    this.props.history.push('/basic/user/order/information/' + item.orderNo);
  }

  toUserBill = (item) => {
    this.props.history.push(`/basic/user/bill?order_no=${item.orderNo}`);
  }

  toEnquiryCart = (item) => {
    this.props.history.push(`/basic/enquiryCart`);
  }

  render() {
    const { orderList, emptyStatus, loading, paginationProps } = this.state;
    const empty = (<div className="order-empty"><CpEmpty status={emptyStatus} history={this.props.history} action={this.toEnquiryCart} /></div>);

    return (
      <div className="order-list">
        <div className="title">我的询价单</div>
        <div className="order-content">
          <SearchForm ref={el => this.searchRef = el} searchFn={this.searchFn} />
          {
            (orderList.length === 0) ? empty : <RenderList
              formateList={orderList}
              btnClicked={this.btnClicked}
              changeStatus={this.changeStatus}
              toOrderDetail={this.toOrderDetail}
              toUserBill={this.toUserBill}
              handleLogistics={this.handleLogistics}
              perfectInformation={this.perfectInformation}
              expandFn={this.expandFn}
              onHandlerSpot={this.onHandlerSpot}
              toProductDetail={this.toProductDetail}
            />
          }
        </div>
        {/* {orderList.length <= 0 && (<div className="status-empty-tip">当前状态下暂无订单~</div>)} */}
        <div className="pagination">
          {loading || (orderList.length <= 0 && emptyStatus.length) ? null : <Pagination {...paginationProps} />}
        </div>
        <Modal
          open={this.state.modalVisible}
          cancelText="取消"
          okText="确定"
          onOk={() => { this.handleOk(); }}
          onCancel={() => { this.handleCancel(); }}>
          {'是否' + this.state.modalContent + '?'}
        </Modal>
      </div>
    );
  }
}
export default OrderList;